import { all } from 'redux-saga/effects';
import watchGetCompetences from './watchers/getCompetences';
import watchUpdateCompetences from './watchers/updateCompetences';

function* competencesSaga() {
  yield all([watchGetCompetences(), watchUpdateCompetences()]);
}

export default competencesSaga;
